// extracted by mini-css-extract-plugin
module.exports = {"DeleteLink":"TodoTemplateListRow_DeleteLink__iP_2m","DropdownMenuIcon":"TodoTemplateListRow_DropdownMenuIcon__98Z_n"};